<template>
    <div class="BoxWide">
        <div class="TabellaGenerale">
            <div class="loader" v-show="this.isLoading"></div> 
            <table width="100%" border="0" cellspacing="0" cellpadding="0" v-show="!this.isLoading">               
                <tbody>
                    <tr>
                        <th scope="col">Identificativo</th>      
                        <th scope="col">Nome</th>
                        <th scope="col">Nome Sito </th>
                        <th scope="col">Indirizzo Sito </th>
                        <th scope="col">Unità</th>
                        <th scope="col">Reparto</th>
                        <th scope="col">Comparto</th>
                        <th scope="col">Dettaglio</th>
                    </tr>
                    <RigaGrigliaEntita v-for="(entita, index) in this.listaEntitaShow" :key="index" :rigaEntita="entita" :index="index"> </RigaGrigliaEntita> 
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import RigaGrigliaEntita from "@/components/RigaGrigliaEntita.vue";

export default {
    name: "GirgliaEntita",
    data(){
        return {
            listaEntitaShow: null,
            isLoading: true
        }
    },
    components: {
        RigaGrigliaEntita
    },

    props: {
        listaEntita: Array
    },

    watch:{
        listaEntita: function(newValue){
            this.listaEntitaShow = newValue;
            this.isLoading = false;
        }
    }
};
</script>